import axios from "axios";
import API from "../api/axios.js";

export const getDashboard = async () => {
  const response = await API.get("/dashboard");
  return response.data;
};

export const getUsers = async () => {
    const response = await API.get("/dashboard/users");
    return response.data;
};